import moment from 'moment'

export default {
  currentTime () {
    return moment().format('LT')
  },

  currentYear () {
    return moment().format('YYYY')
  },

  format (date: Date | string) {
    return moment(date).format('lll')
  },

  now () {
    return moment().format()
  },

  nowUtc () {
    return moment().utc().format()
  },

  startOfWeek () {
    return moment().startOf('isoWeek').utc().format()
  },

  startOfMonth () {
    return moment().startOf('month').utc().format()
  },

  toUtc (date: Date) {
    return moment(date).utc().format()
  },

  fromNow (date: string) {
    return moment().to(moment(date))
  }
}
